import React, { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { applyScrollTarget, scrollTargetOnNavigate } from '../../utils/scrollOnNavigate';

/**
 * Opens a page the user navigated to at its top — or at the section its link names
 * (`?page=terms#data-sources`) — instead of the scroll position of the page the link was on
 * (public-site R13, F-PUB6). Back / forward and the first load keep the browser's position.
 * `key` is new on every navigation, also a click on a link to the page already open.
 */
const ScrollOnNavigate: React.FC = () => {
  const { key, hash } = useLocation();
  const navigationType = useNavigationType();
  useEffect(() => {
    applyScrollTarget(scrollTargetOnNavigate(navigationType, hash), window, document);
  }, [key, hash, navigationType]);
  return null;
};

export default ScrollOnNavigate;
